import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';
import Autocomplete, { highlightSubstring } from '../Autocomplete';
import ListItemText from '@material-ui/core/ListItemText';

const ServicePointSearch = ({ carrier, countryCode, postalCode, ...props }) => {
  const [servicePointSuggestions, setServicePointSuggestions] = useState([]);
  const [isFetchingServicePoints, setIsFetchingServicePoints] = useState(true);

  const renderServicePointOption = (option, { inputValue = '' } = {}) => {
    let optionLabel = option;

    if (typeof option === 'object') {
      // eslint-disable-next-line prefer-destructuring
      optionLabel = option.label;
    }

    return (
      <ListItemText
        primary={highlightSubstring(optionLabel, inputValue)}
        secondary={highlightSubstring(
          `${option?.address?.address_line_1}, ${option?.address?.postal_code} ${option?.address?.locality}, ${option?.address?.country_code}`,
          inputValue,
        )}
      />
    );
  };

  useEffect(() => {
    let isMounted = true;

    const fetchServicePoints = async () => {
      try {
        setIsFetchingServicePoints(true);

        const response = await fulfilmentApi.listServicePoints(carrier, countryCode, postalCode);
        const { data } = response;

        if (isMounted) {
          setServicePointSuggestions(
            data.map(servicePoint => ({
              ...servicePoint?.point,
              value: servicePoint?.point?.id,
              label: servicePoint?.point?.name,
            })),
          );
        }
      } catch (err) {
        if (isMounted) {
          setServicePointSuggestions([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingServicePoints(false);
        }
      }
    };

    if (carrier && countryCode && postalCode && postalCode !== '') {
      fetchServicePoints();
    }

    return () => {
      isMounted = false;
    };
  }, [carrier, countryCode, postalCode]);

  return (
    <Autocomplete
      {...props}
      options={servicePointSuggestions}
      loading={isFetchingServicePoints}
      renderOption={renderServicePointOption}
    />
  );
};

ServicePointSearch.propTypes = {
  carrier: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  postalCode: PropTypes.string.isRequired,
};

ServicePointSearch.defaultProps = {
  countryCode: 'NL',
};

export default ServicePointSearch;
